//constants
import { LABELS } from "@payment-client/analytics/constants";
import {
    BAD_DEBIT_CODE,
    CARD_RATE_LIMIT_EXCEEDED_STATUS_CODE,
    IM_DUPLICATE_ORDER_STATUS_CODE,
    IM_DUPLICATE_PAYMENT_STATUS_CODE,
    ORDER_INTERRUPTION_STATUS_CODE,
    ORDER_TERMINAL_STATUS_CODE,
    PAST_PAYMENT_PENDING_STATUS_CODE,
    DINEOUT_BILL_PAYMENT_INVALID_QR_STATUS_CODE,
    PAYMENT_MAX_RETRIES_EXCEEDED_SOFT_FAILURE_STATUS_CODE,
    PAYMENT_MAX_RETRIES_EXCEEDED_STATUS_CODE,
} from "@payment-client/constants/StatusCodes";
import { NAVIGATION_ORDER_INTERRUPTION_SCREENS } from "@payment-client/constants/TextDict";

//helpers
import { isBusinessLineRegular } from "./Misc";
import { NavigationTypes } from "@swiggy-private/native-bridge";
import { ACTION_TYPES, OrderInterruptionAlertData, OrderApiData } from "@swiggy-private/payment-types";
import { ApiResponse } from "@swiggy-private/core-utils";

export const getOrderInterruptionNavigateScreenLabel = (screenName?: string): string => {
    switch (screenName) {
        case NAVIGATION_ORDER_INTERRUPTION_SCREENS.ORDER_DETAIL:
            return LABELS.REVIEW_CART;
        case NAVIGATION_ORDER_INTERRUPTION_SCREENS.CART:
            return LABELS.REVIEW_ORDER;
        case NAVIGATION_ORDER_INTERRUPTION_SCREENS.DISMISS:
            return LABELS.DISMISS;
        case NAVIGATION_ORDER_INTERRUPTION_SCREENS.IM_CART:
            return LABELS.REVIEW_IM_CART;
        default:
            return "-";
    }
};

export const isOrderInterruptionStatusCode = (err?: { statusCode: number }): boolean | undefined => {
    if (err && err.statusCode === PAYMENT_MAX_RETRIES_EXCEEDED_STATUS_CODE) {
        return isBusinessLineRegular();
    }
    const statusCodesToCheck = [
        ORDER_INTERRUPTION_STATUS_CODE,
        BAD_DEBIT_CODE,
        IM_DUPLICATE_ORDER_STATUS_CODE,
        IM_DUPLICATE_PAYMENT_STATUS_CODE,
        PAYMENT_MAX_RETRIES_EXCEEDED_STATUS_CODE,
        PAST_PAYMENT_PENDING_STATUS_CODE,
        CARD_RATE_LIMIT_EXCEEDED_STATUS_CODE,
        PAYMENT_MAX_RETRIES_EXCEEDED_SOFT_FAILURE_STATUS_CODE,
        DINEOUT_BILL_PAYMENT_INVALID_QR_STATUS_CODE,
    ];
    return err && statusCodesToCheck.includes(err.statusCode);
};

export const isConfirmApiOrderInterruptionStatusCode = (err?: { statusCode: number }): boolean => {
    if (
        (err && err.statusCode === PAYMENT_MAX_RETRIES_EXCEEDED_STATUS_CODE) ||
        err?.statusCode === ORDER_TERMINAL_STATUS_CODE
    ) {
        return isBusinessLineRegular();
    }
    return (
        !!err &&
        [PAYMENT_MAX_RETRIES_EXCEEDED_SOFT_FAILURE_STATUS_CODE, DINEOUT_BILL_PAYMENT_INVALID_QR_STATUS_CODE].includes(
            err.statusCode,
        )
    );
};

export const isDuplicateOrder = (statusCode: number): boolean => {
    return (
        statusCode === ORDER_INTERRUPTION_STATUS_CODE ||
        statusCode === IM_DUPLICATE_ORDER_STATUS_CODE || // this is for im confirm order
        statusCode === IM_DUPLICATE_PAYMENT_STATUS_CODE // this is for im pending/created order
    );
};

export const getOrderInterruptionAlertData = (err: ApiResponse<OrderApiData>): OrderInterruptionAlertData => {
    if (err?.statusCode === DINEOUT_BILL_PAYMENT_INVALID_QR_STATUS_CODE) {
        return {
            title: err?.statusTitle || "",
            subtitle: err?.statusMessage || "",
            actions: [
                {
                    actionType: ACTION_TYPES.NAVIGATE,
                    displayName: err?.ctaText || "",
                    actionData: {
                        type: NavigationTypes.DEEPLINK,
                        link: err?.ctaAction?.meta?.deeplink || "",
                        shouldCloseWebview: true,
                    },
                },
            ],
        } as OrderInterruptionAlertData;
    }

    return err?.data?.orderInterruptionData as OrderInterruptionAlertData;
};
